module.exports = __webpack_public_path__ + "img/icon_up.3a135d8f.svg";